import TemplatePointers from "./components/TemplatePointers"
import React from 'react';
import { useTheme } from '@mui/material/styles';


function LandingIntro(){
    const theme = useTheme();

    return(
        <div className="hero min-h-full rounded-l-xl" style={{backgroundColor: theme.palette.primary.main}}>
            <div className="hero-content py-12">
              <div className="max-w-md">

              <h1 className='text-3xl text-center font-bold '><img src="./NucleusLogoStackedReversed.png" className="w-100 inline-block mr-2" alt="nucleus-logo" /></h1>

                {/* <div className="text-center mt-12"><img src="./intro.png" alt="Nucleus Portal" className="w-48 inline-block"></img></div>
               */}
              {/* Importing pointers component */}
              <TemplatePointers />
              
              </div>

            </div>
          </div>
    )
      
  }
  
  export default LandingIntro